/**
 * Content Switcher Component
 */
window.SLDS = window.SLDS || {};

window.SLDS.contentSwitcher = () => ({
  current: 1,
  contentSwitcherHeight: null,
  interacted: false,

  init() {
    this.$nextTick(() => {
      this.contentSwitcherHeight = this.$root.offsetHeight;
    });
  },

  setCurrent(index) {
    this.interacted = true;
    this.current = index;
  },
});
